export default {"src":"/_next/static/media/icon-password.14e84ef5.svg","height":16,"width":16};